import { useTranslation } from 'react-i18next';
import {
  InquiryVersioningChoice,
  type LlmChatUiActionInquiryVersioningChoice,
} from '@paladin-monorepo/common';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LlmChatInquiryVersioningActionsProps {
  uiAction: LlmChatUiActionInquiryVersioningChoice;
  disabled?: boolean;
  onSelect: (choice: InquiryVersioningChoice) => void;
  className?: string;
}

const CHOICE_I18N: Record<InquiryVersioningChoice, { label: string; description: string }> = {
  [InquiryVersioningChoice.UpdateCurrent]: {
    label: 'llmChat.versioning.updateCurrent',
    description: 'llmChat.versioning.updateCurrentDescription',
  },
  [InquiryVersioningChoice.CreateNew]: {
    label: 'llmChat.versioning.createNew',
    description: 'llmChat.versioning.createNewDescription',
  },
};

export function LlmChatInquiryVersioningActions({
  uiAction,
  disabled,
  onSelect,
  className,
}: LlmChatInquiryVersioningActionsProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('mt-3 space-y-2 border-t border-border/60 pt-3', className)}>
      <p className="text-sm font-medium">{t('llmChat.versioning.title')}</p>
      <p className="text-xs text-muted-foreground">{t('llmChat.versioning.description')}</p>
      <div className="flex flex-col gap-2">
        {uiAction.options.map((option) => {
          const keys = CHOICE_I18N[option.value];
          return (
            <Button
              key={option.value}
              type="button"
              variant="outline"
              size="sm"
              className="h-auto flex-col items-start gap-0.5 whitespace-normal py-2 text-left"
              disabled={disabled}
              onClick={() => onSelect(option.value)}
            >
              <span className="font-medium">{t(keys.label)}</span>
              <span className="text-xs font-normal text-muted-foreground">{t(keys.description)}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}

export function getVersioningChoiceDisplayLabel(
  choice: InquiryVersioningChoice,
  translate: (key: string) => string,
): string {
  return translate(CHOICE_I18N[choice].label);
}
